import React, { useState } from 'react';

function PostEncounterMsgPopup({ headerData, close }) {
  const [status, setStatus] = useState('');
  const [requester, setRequester] = useState('');

  const [msg, setMsg] = useState('');

  const handleSave = () => {};
  return (
    <div className="modalBackground">
      <div className="insu-act-sec pe-mssg-main-con ">
        <div className="main-contnr-hdr flex-sec white-bg">
          <div className="hdr-pt-info">
            <span className="black-txt clear-right10">
              Post-encounter message:
            </span>
            <span className="width100 clear-right10" style={{ float: 'left' }}>
              {headerData?.patName}
              <span className="red"> | </span>
              ID: {headerData?.chart_number}
              <span className="red"> | </span>
              {headerData?.age}-[{headerData?.gender.toUpperCase().substr(0, 1)}
              ]<span className="red"> | </span>
              DOB:{headerData?.dob}
            </span>
          </div>
          <div className="close" onClick={close}>
            X
          </div>
        </div>
        <div className="insu-act-sec-bdy fontsize13">
          <div className="insu-act-sec-bdy-lft flex-sec  alt-rw">
            <span className="nsu-act-lbl">Message Type:</span>
            <span className="nsu-act-val">
              <select className="pe-msg-dd">
                <option value=""></option>
                <option value="1">
                  Electronic copy for health information
                </option>
                <option value="2">Amendment</option>
                <option value="3" selected="">
                  Post Encounter
                </option>
                <option value="4">Addendum</option>
              </select>
            </span>
          </div>
          <div className="insu-act-sec-bdy-lft flex-sec">
            <span className="nsu-act-lbl">Status:</span>
            <span className="nsu-act-val">
              <span className="appt-check-sec" style={{ marginLeft: '0px' }}>
                <span className="book-appt-check">
                  <input
                    onChange={(e) => setStatus(e.target.value)}
                    type="radio"
                    value="new"
                    checked={status === 'new'}
                  />
                </span>
                <span className="book-appt-check-val">New</span>
              </span>
              <span className="appt-check-sec">
                <span className="book-appt-check">
                  <input
                    onChange={(e) => setStatus(e.target.value)}
                    type="radio"
                    value="accept"
                    checked={status === 'accept'}
                  />
                </span>
                <span className="book-appt-check-val">Accept</span>
              </span>
              <span className="appt-check-sec">
                <span className="book-appt-check">
                  <input
                    onChange={(e) => setStatus(e.target.value)}
                    type="radio"
                    value="deny"
                    checked={status === 'deny'}
                  />
                </span>
                <span className="book-appt-check-val">Deny</span>
              </span>
              <span className="appt-check-sec">
                <span className="book-appt-check">
                  <input
                    onChange={(e) => setStatus(e.target.value)}
                    type="radio"
                    value="completed"
                    checked={status === 'completed'}
                  />
                </span>
                <span className="book-appt-check-val">Completed</span>
              </span>
            </span>
          </div>
          <div className="insu-act-sec-bdy-lft flex-sec  alt-rw">
            <span className="nsu-act-lbl"> Assign to Staff:</span>
            <span className="nsu-act-val">
              <select className="pe-msg-dd">
                <option value=""></option>
                <option value="1">Harish Goyal, MD</option>
                <option value="2">Shaveta Goyal, MD</option>
                <option value="3">Ana Taduran</option>
                <option value="4">John Getz, Psyd</option>
              </select>
            </span>
          </div>
          <div className="insu-act-sec-bdy-lft flex-sec">
            <span className="nsu-act-lbl">Requester:</span>
            <span className="nsu-act-val">
              <span className="appt-check-sec" style={{ marginLeft: '0px' }}>
                <span className="book-appt-check">
                  <input
                    onChange={(e) => setRequester(e.target.value)}
                    type="radio"
                    value="self"
                    checked={requester === 'self'}
                  />
                </span>
                <span className="book-appt-check-val">Self</span>
              </span>
              <span className="appt-check-sec">
                <span className="book-appt-check">
                  <input
                    onChange={(e) => setRequester(e.target.value)}
                    type="radio"
                    value="familyMember"
                    checked={requester === 'familyMember'}
                  />
                </span>
                <span className="book-appt-check-val">
                  Family member / Patient authorised person
                </span>
              </span>
              <span className="appt-check-sec">
                <span className="book-appt-check">
                  <input
                    onChange={(e) => setRequester(e.target.value)}
                    type="radio"
                    value="thirdParty"
                    checked={requester === 'thirdParty'}
                  />
                </span>
                <span className="book-appt-check-val">Other third party</span>
              </span>
            </span>
          </div>
          <div className="insu-act-sec-bdy-lft flex-sec alt-rw">
            <span className="nsu-act-lbl">Message:</span>
            <span className="nsu-act-val">
              <textarea
                onChange={(e) => setMsg(e.target.value)}
                className="alert-txt-area"
                placeholder=""
                value={msg}
              ></textarea>
            </span>
          </div>
        </div>
        <div
          className="insu-act-sec-bdy-rw white-bg"
          style={{
            padding: '9px 0px 0px',
            display: 'inline-block',
            marginBottom: '0px',
          }}
        >
          <button
            className="actn-yes"
            style={{ width: '20%' }}
            onClick={handleSave}
          >
            Save
          </button>
          <button className="actn-No" style={{ width: '20%' }} onClick={close}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

export default PostEncounterMsgPopup;
